<app-sysinfo-view [versionData]="versionData$ | async"
    [launchResources]="launchResources$ | async">
</app-sysinfo-view>